"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _preact = require("preact");

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _dropdown = _interopRequireDefault(require("@insided/deprecated-preact-components/design-system-components/dropdown"));

var _Categories = require("@insided/shared/modules/Categories");

var _listGroup = _interopRequireDefault(require("@insided/deprecated-preact-components/design-system-components/list-group"));

var _chip = _interopRequireDefault(require("@insided/deprecated-preact-components/design-system-components/chip"));

var _NestedDropdown = _interopRequireDefault(require("@insided/shared/uikit/NestedDropdown"));

var _ArrowDropdown = _interopRequireDefault(require("@insided/shared/icons/ArrowDropdown"));

var _Close = _interopRequireDefault(require("@insided/shared/icons/Close"));

var _categories = require("@insided/shared/utils/categories");

var _NestedDropdownHeader = _interopRequireDefault(require("@insided/shared/uikit/NestedDropdown/NestedDropdownHeader"));

var _Button = _interopRequireDefault(require("@insided/shared/uikit/Button"));

var _SearchBox = _interopRequireDefault(require("@insided/deprecated-preact-components/search-box/SearchBox"));

var _createDeepCopy = require("@insided/shared/utils/createDeepCopy");

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var CategoriesComponent = /*#__PURE__*/function (_Component) {
  (0, _inherits2.default)(CategoriesComponent, _Component);

  var _super = _createSuper(CategoriesComponent);

  function CategoriesComponent() {
    var _this;

    (0, _classCallCheck2.default)(this, CategoriesComponent);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "state", {
      categories: (0, _categories.getNonEmptyCategories)(_this.props.categories),
      searchTextForCategory: ''
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "removeSelectedCategory", function (pill) {
      var idxToDelete = _this.props.selectedCategories.findIndex(function (category) {
        return category.id === pill.id;
      });

      var newListOfCategories = _this.props.selectedCategories.concat([]);

      newListOfCategories.splice(idxToDelete, 1);

      _this.props.onChangeCategories(newListOfCategories);
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "onSelect", function (categoryId, checked) {
      var selectedCategories = _this.props.selectedCategories;
      var categories = _this.state.categories;
      var category = (0, _categories.findCategoryById)((0, _categories.getMergedCategoryList)(categories), categoryId);
      if (!category) return;
      var childrenContentCategories = [];

      if (category.isContainer) {
        childrenContentCategories = (0, _categories.getContentCategories)((0, _categories.flattenCategoryList)(category.children));
      }

      if (checked) {
        var updatedSelectedCategories = (0, _categories.addCategoryIdsToList)(selectedCategories, category, childrenContentCategories);

        _this.props.onChangeCategories(updatedSelectedCategories);
      } else {
        var _updatedSelectedCategories = (0, _categories.removeCategoryIdsFromList)(selectedCategories, category, childrenContentCategories);

        _this.props.onChangeCategories(_updatedSelectedCategories);
      }
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "onChangeSearch", function (searchText) {
      _this.setState({
        searchTextForCategory: searchText
      });
    });
    return _this;
  }

  (0, _createClass2.default)(CategoriesComponent, [{
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props = this.props,
          _this$props$label = _this$props.label,
          label = _this$props$label === void 0 ? 'Published in' : _this$props$label,
          modulesToDisplay = _this$props.modulesToDisplay,
          selectedCategories = _this$props.selectedCategories;
      var _this$state = this.state,
          categories = _this$state.categories,
          searchTextForCategory = _this$state.searchTextForCategory;
      return (0, _preact.h)("div", null, (0, _preact.h)(_dropdown.default, {
        size: "full-width",
        textButtonStyle: {
          width: '100%',
          marginBottom: '8px'
        },
        customHeight: "250px",
        className: "dropdown-selector",
        popupName: "categories-selection",
        trigger: (0, _preact.h)("div", {
          className: "categories_dropdown-selection"
        }, (0, _preact.h)("label", {
          htmlFor: "categories_dropdown-selection"
        }, label), (0, _preact.h)(_Button.default, {
          icon: (0, _preact.h)(_ArrowDropdown.default, {
            width: 24,
            height: 24
          }),
          title: "Select categories",
          fullWidth: true,
          size: "medium",
          style: {
            fontWeight: 'normal'
          },
          id: "categories_dropdown-selection"
        }))
      }, (0, _preact.h)(_SearchBox.default, {
        isModerationOverview: true,
        placeholder: "Search",
        value: searchTextForCategory,
        onSubmit: function onSubmit() {},
        onInput: function onInput(e) {
          return _this2.onChangeSearch(e.target.value);
        },
        onClear: function onClear() {
          return _this2.onChangeSearch('');
        }
      }), Object.entries(categories).map(function (_ref) {
        var _ref2 = (0, _slicedToArray2.default)(_ref, 2),
            module = _ref2[0],
            categories = _ref2[1];

        var categoryName = (0, _categories.getModuleNameFromType)(parseInt(module)); // Using JSON.parse(JSON.stringify(categories)) to create a deep copy of the categories object.
        // This ensures immutability while working with the filteredCategories variable, avoiding unintended mutations.

        var filteredCategories = (0, _createDeepCopy.createDeepCopy)(categories); // If modulesToDisplay is defined and the current category is not in the list, don't display it

        if (typeof modulesToDisplay !== 'undefined' && !modulesToDisplay.includes(categoryName)) {
          filteredCategories = [];
        }

        if (_this2.state.searchTextForCategory) {
          filteredCategories = (0, _categories.filterCategoriesByTitle)(filteredCategories, _this2.state.searchTextForCategory);
        }

        if (filteredCategories.length === 0) {
          return null;
        }

        return (0, _preact.h)("div", {
          key: categoryName
        }, (0, _preact.h)(_NestedDropdownHeader.default, null, categoryName), (0, _preact.h)(_NestedDropdown.default, {
          items: filteredCategories,
          onMultiSelect: _this2.onSelect,
          selectedItems: selectedCategories.map(function (category) {
            return category.id;
          }),
          depth: 1
        }));
      })), selectedCategories.length > 0 && (0, _preact.h)(_listGroup.default, {
        spacing: "4px"
      }, selectedCategories.map(function (category) {
        return (0, _preact.h)(_chip.default, {
          key: category.id,
          variant: "squared",
          size: "small",
          endIcon: (0, _preact.h)(_Close.default, {
            width: 14,
            height: 14
          }),
          onClick: function onClick() {
            _this2.removeSelectedCategory(category);
          }
        }, category.title);
      })));
    }
  }]);
  return CategoriesComponent;
}(_preact.Component);

var _default = (0, _Categories.withCategoriesContext)(CategoriesComponent);

exports.default = _default;